import * as serviceWorker from './serviceWorker';

import 'babel-polyfill';

import React, {Component, Suspense} from 'react';
import ReactDOM from 'react-dom';
import {Route, Router, Switch, Redirect} from 'react-router-dom';
import {createStore, applyMiddleware} from 'redux';
import createSagaMiddleware from 'redux-saga';
import {Provider} from 'react-redux';
import {createLogger} from 'redux-logger';
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";


import reducer from './reducers';
import rootSaga from './sagas';
//import {clearError} from './actions'

import history from './components/common/history';


import App from './components/App';
//import NotFound from './components/NotFound'

import {/*setAuthToken,*/ getAuthToken} from './auth/token';

import { put } from 'redux-saga/effects';

import Auth from './components/auth/Auth';
import Dashboard from './components/Dashboard';
import Lesson from './components/lesson/Lesson';
import ReactGA from 'react-ga';

import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV && process.env.NODE_ENV !== 'development'){  // TODO: make sure !== vs != produce correct results
    ReactGA.initialize('UA-158933671-1');
    ReactGA.pageview(window.location.pathname + window.location.search);
}


const Profile = React.lazy(() => import('./components/profile/Profile'));

const About = React.lazy(() => import('./components/About'));
const PrivacyPolicy = React.lazy(() => import('./components/PrivacyPolicy'));
const TermsAndConditions = React.lazy(() => import('./components/TermsAndConditions'));
const InitialTest = React.lazy(() => import('./components/what_to_learn/InitialTest'));

const CoursesDashboard = React.lazy(() => import('./views/CoursesDashboard'));
const JoinFromInvitation = React.lazy(() => import('./views/JoinFromInvitation'));
const Store = React.lazy(() => import('./views/Store') );
const Streak = React.lazy(() => import('./views/Streak') );
const Feed = React.lazy(() => import('./views/Feed') );
const League = React.lazy(() => import('./views/League') );


const LessonIntroduction = React.lazy(() => import('./components/lesson/LessonIntroduction'));
const LessonCompleted = React.lazy(() => import('./components/lesson/LessonCompleted'));




Sentry.init({dsn: "https://af3d1a5ace43447c8c5e9213b989b218@sentry.io/3766579"});


const logger = createLogger({
  // Ignore `FORBIDDEN_ACTION`
  predicate: (getState, action) => (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')? action.type !== 'FORBIDDEN_ACTION': false
})


const sagaMiddleware = createSagaMiddleware()

// Creates the Redux store using our reducer and the logger and saga middlewares
const store = createStore(reducer, applyMiddleware(logger, sagaMiddleware))

// We run the root saga automatically
sagaMiddleware.run(rootSaga)

/**
* Checks authentication status on route change
* @param  {object}   nextState The state we want to change into when we change routes
* @param  {function} replace Function provided by React Router to replace the location
*/
function isAuth () {
    /*console.log('isAuth')
    console.log(store.getState())*/
    const {isLoggedIn} = store.getState()
    //console.log(loggedIn)
    //store.dispatch(clearError())
    if (isLoggedIn){
        //console.log("LOGGED IN")
        return true;
    }
    return false;
}



// Mostly boilerplate, except for the routes. These are the pages you can go to,
// which are all wrapped in the App component, which contains the navigation etc
class AppFlow extends Component {

    /*componentDidMount(){
        console.log('-------------')
        console.log(getAuthToken())
        console.log('-------------')
    }*/
    componentDidMount(){
        //TODO: fetch special token from API, it should be set by the other part of the app and retrieved once here
        put({type: 'SYNCHRONIZE_TEST_STATE_REQUEST', testId: getAuthToken()})
    }

    render () {
        return (
            <Provider store={store}>
                <Router history={history}>
                    <I18nextProvider i18n={i18n}>
                        <App>
                            <Suspense fallback={<div></div>}>
                                <Switch>
                                    <Route path='/auth' render={() => isAuth()?<Redirect to="/learn"/>: <Auth/>} />

                                    <ProtectedRoute path='/courses' component={CoursesDashboard} />

                                    <ProtectedRoute path='/learn' component={Dashboard} />
                                    <ProtectedRoute path='/learn/:language' render={<div/>} />
                                    <ProtectedRoute path='/lesson/:language/:lessonTitle/:level' component={Lesson}/>

                                    <ProtectedRoute path='/profile' component={Profile}/>
                                    <ProtectedRoute path='/profile/:userSlug' component={Profile}/>

                                    <Route path='/terms-and-conditions' render={()=> <TermsAndConditions/>}/>
                                    <Route path='/privacy-policy' render={()=> <PrivacyPolicy/>}/>
                                    <Route path='/about' render={()=> <About/>}/>
                                    <Route path='/initial-test' render={()=><InitialTest/>}/>
                                    <Route path='/join/:invitationHash' render={() => isAuth()?<Redirect to="/learn"/>: <Auth/>}/>


                                    <Route path='/debug/courses' render={() => <CoursesDashboard/>} />
                                    <Route path='/debug/lesson/:language/:lessonTitle/:level' render={() => <Lesson/>}/>
                                    <Route path='/debug/lesson/introduction' render={() => <LessonIntroduction lessonTitle={'Numbers'} lessonIntroductionContent={'Hello, this is code: <br> `print("hello world!")`'}/>} />
                                    <Route path='/debug/lesson/completed' render={()=><LessonCompleted exp={15} time={112.5} accuracy={92}/>} />


                                    <Route path='*' render={() => isAuth()?<Redirect to="/learn"/>: <Redirect to="/auth"/>} />
                                </Switch>
                            </Suspense>
                        </App>
                    </I18nextProvider>
                </Router>
            </Provider>
        )
    }
}


class ProtectedRoute extends Component {
  render() {
    const { component: Component, ...props } = this.props

    return (
      <Route
        {...props}
        render={props => (
          isAuth() ?
            <Component {...props} /> :
            <Redirect to='/auth' />
        )}
      />
    )
  }
}


const isPlayground = window.location.pathname.includes("playground");


//const preloadedState = {
//    user: { isLoggedIn: true, accessToken: "mock_token" }
//};

function getLessons(){
    return [
        [
            {'title': 'beginning', 'icon':'/images/lesson-icons/begin.svg', 'level': 1, 'lessonsCompleted': 1, 'totalLessons': 3, completed: true}
            //'/images/terminal.png'
        ],
        [
            {'title': 'print', 'icon': 'http://icons.iconarchive.com/icons/froyoshark/enkel/512/Terminal-icon.png', 'level': 0, 'lessonsCompleted': 1, 'totalLessons': 3},
            {'title': 'numbers', 'icon': 'https://images.cdn3.stockunlimited.net/preview1300/maths-subject-icon_1964721.jpg', 'level': 0, 'lessonsCompleted': 1, 'totalLessons': 3,}
        ],
        [
            {'title': 'text operations', 'icon': 'https://cdn0.iconfinder.com/data/icons/tab-bar-ios-and-wp8-vector-icons/48/align_left-512.png', 'level': 1, 'lessonsCompleted': 1, 'totalLessons': 3},
            {'title': 'operators', 'icon': 'https://static.thenounproject.com/png/186400-200.png', 'level': 1, 'lessonsCompleted': 1, 'totalLessons': 3}
            //'/images/circle-x.png'
        ],

        [
            {'type': 'checkpoint', 'title': 'checkpoint 1', 'icon': 'https://cdn.iconscout.com/icon/premium/png-256-thumb/checkpoint-1673231-1420281.png'}
        ],

        [
            {'title': 'variables', 'icon': 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAaVBMVEX///8BAQEAAAD5+fk9PT3Y2NjV1dUtLS03NzddXV2zs7NgYGCDg4ORkZGHh4fz8/N7e3v19fVVVVXJycnj4+NoaGhKSkrr6+uoqKifn59vb29fX1/d3d0oKCgyMjK5ubmQkJBDQ0MhISE8938HAAAFGElEQVR4nO2d61rqMBBF01ZFUCwXAQUV9f0f8hw9nzCTzkxzEJJB9/pnb2Sx2zQ3NQQAAAAAAAAAAAAAAAAAAAAAAAC/g+ZMOFhwcX1xFswOVWxe6vPg+WDD67o6B+oBDGHoHRjC0D8whKF/jmZYum3GOIVhaaeI4xvW9ejSDyOqeDTDywMvcwouT2J4ddQyfo8rGKYBw4LAMBEYFgSGicCwIDBMJDJ8OmoZv8fTSQyXm6EXNssTGP78/qFjYAhD/8AQhv6BIQz9A8NUw9IN0YjjG9b1eDvywnaMeYs0fl0fH4Y5gWEiMCwIDBOBYUFgmAgMCwLDRGBYEBgmAsOCwDCR/zAc3+6YbHfFmNwSRuyEEd012V16S04ZezJ8oON87dfWFR//o8Vo+K7V1/aWbn3wY3hPPq8mX/0dG9WkmYzZnjtxR13fuzFc0GJN99tbVg4SYsN3tPtTpvTLWnsxpItbaB56iGqE7BRjCU9mw4VaKCVEPcLo61r4MGRP4ZDvk0M0IgxhmPIk5jUc0aOi+k8M0Yrwo14mO/krppThm1LPfCKFaEbI65o3D4ZPZu0Xhfi5zYwwhHVCXZPV8NG+q7oh2hFGd71ym2Y1ZDVDJxAhxJ4I2RlxzVXCcPXeU7vHIfZFyN8+7yvhgLyGdK6yfhUOiKvTvghDeKV3hTwvm9NwS48Ri8NDrHoj/PulkSO20hFZDdf2YxiiELlg/wlK2zSn4YyUZil/EguRIkcYmiW55kw8JKNhOyCluZWvw0PsjTCEW3LNgXhMRkPWKH1ULqSEqETIXrFK0zSjIatKtfUocohqhLSqUSrTjIZXvRXNB2KIaoS8qlE+NpvhQ5KhFGLi4fJoTUZDOq4yiDsWe4QQ9QjDlFZf4pBbRkNa7Skviw+6IRoR8teFWEFnNKQvfH3gSAjRiDDhqhkNaSt5YlxrGoXY7StTJn1jNRkNbxIN4xDNCN0aKk2af/AQ7QjZ030jHZDRcJhqSO9na5zwE2oo9oE9ZthEGZqFooYb6QCPz+E4MrRmllw9h6l1adOpS61SeTJcJxqOO4ZWiNSw9PuQlmVpXEpo0+jFctWmoe3SF/2D4gjtEOkHF2+XpvUtuhGaIbrqW1wmGXYjNENkhqV7wKyPr83dxI3Srytq7RrWrS5tyOZltHEaKUIrRDZOI87NOBtrkyM0QnQ11sbGS5VpFDlCI0Ta2C0+Xson8cXvO+pV9IfIKhq5iZ7TkE1Ki7UC/006/oPysiOHyMuGis09SQWecqcV/1EKka0aKj/3xOYPpd4qj/COdfblEGl/xcH8IZ8D7kYSRdjEKzHsMzzMAbM53Xou7OYRht4Q53S/UtuWW4vR6UBNu4kJmxi0u+JiLUag62mquLzdCPtCnJIXio/1NOZt2kp5RSFGL1F2k766MLTWtUkR9oTocF0bq91rVruLEdohrvobNPkN5+qCEzlCM0S21KRbNZcxZK3viiSiRGiF2Fb6LV/QkH4e7SRqERohsq6h/lccsq/Vv6N/kmOXSMsX5NMXyZTv2p9Ska3G5E3+37dYb26+mO1WMc1nN3uGfADgcUj2zXbP23Z/ysaajsTvzCQCw4LAMBEYFgSGicCwIDBMBIYFgWEiMCwIDBOBYUFgmMiv+/ulP/1/51W1L6rjG/pSrE5h6BYYwtA/MIShf2AIQ/98w/CldNsskedDDcPi+uIsmB1sGJoz4WBBAAAAAAAAAAAAAAAAAAAAAAAAZ8UfPhyC+QS1BVkAAAAASUVORK5CYII=', 'level': 1, 'lessonsCompleted': 0}
        ],
        [
            {'title': 'conditions', 'icon': 'https://static.thenounproject.com/png/582083-200.png', 'level': 1, 'lessonsCompleted': 0}
            //'https://cdn2.iconfinder.com/data/icons/strategy-3/100/strategy-tactic-04-512.png',
        ],
        [
            {'title': 'loops', 'icon': 'http://iconshow.me/media/images/ui/ios7-icons/png/512/loop.png', 'level': 1, 'lessonsCompleted': 0}
        ],

        [
            {'title': 'booleans', 'icon': 'https://image.flaticon.com/icons/png/512/1829/1829922.png', 'level': 1, 'lessonsCompleted': 0},
            {'title': 'NULLs', 'icon': 'https://cdn2.iconfinder.com/data/icons/ninja/500/Ninja_12-512.png', 'level': 1, 'lessonsCompleted': 0}
        ], //https://image.flaticon.com/icons/png/512/1829/1829876.png'
           //https://icon-library.net/images/true-false-icon/true-false-icon-1.jpg
           //https://icon-library.net/images/true-false-icon/true-false-icon-2.jpg
           //https://i.ya-webdesign.com/images/yes-no-icon-png-6.png

        [
            {'title': 'types', 'icon': 'data:image/png;base64,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', 'level': 1, 'lessonsCompleted': 0},
        ],

        [
            {'type': 'checkpoint', 'title': 'checkpoint 2', 'icon': 'https://cdn.iconscout.com/icon/premium/png-256-thumb/checkpoint-1673231-1420281.png'}
        ],

        [
            {'title': 'lists', 'icon': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsRPEPQSRd3tPCrGy04w9MVOscmvQlJpARCy5m8yAyu3-v7wEC&s', 'level': 1, 'lessonsCompleted': 0},
            {'title': 'dictionaries', 'icon': 'https://img.icons8.com/plasticine/2x/book.png', 'level': 1, 'lessonsCompleted': 0},
            {'title': 'tuples', 'icon': undefined, 'level': 1, 'lessonsCompleted': 0},
        ],

        [
            {'title': 'comprehension', 'icon': 'https://cdn2.iconfinder.com/data/icons/mental-activity/96/mental_working_brain_comprehension-512.png', 'level': 1, 'lessonsCompleted': 0}
        ],

        [
            {'title': 'functions', 'icon': 'https://images-na.ssl-images-amazon.com/images/I/514JWN7NULL.png', 'level': 1, 'lessonsCompleted': 0}
        ],

        [
            {'type': 'checkpoint', 'title': 'checkpoint 3', 'icon': 'https://cdn.iconscout.com/icon/premium/png-256-thumb/checkpoint-1673231-1420281.png'}
        ],

        //[
        //    {'title': 'recursion', 'icon': undefined, 'level': 1, 'lessonsCompleted': 1, 'isBonus': true}
        //],

        [
            {'title': 'modules', 'icon': 'https://cdn.iconscout.com/icon/premium/png-256-thumb/module-3-560103.png', 'level': 1, 'lessonsCompleted': 0}
        ],

        [
            {'title': 'classes', 'icon': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPWadBqC6N_n0ibB4ZMT0YCds6ab3IMXjw0rpTZBjGdvw1QYre&s', 'level': 1, 'lessonsCompleted': 0}
        ],

        [
            {'title': 'imports', 'icon': 'https://cdn3.iconfinder.com/data/icons/interaction-design/512/Import_A-512.png', 'level': 1, 'lessonsCompleted': 0}
        ],

        [
            {'type': 'checkpoint', 'title': 'checkpoint 4', 'icon': 'https://cdn.iconscout.com/icon/premium/png-256-thumb/checkpoint-1673231-1420281.png'}
        ],

        [
            {'title': 'standard library 1', 'icon': 'https://banner2.cleanpng.com/20180719/piz/kisspng-north-carolina-wesleyan-college-library-science-no-library-icon-5b50c910354111.3735460915320210082181.jpg', 'level': 1, 'lessonsCompleted': 0},
            {'title': 'standard library 2', 'icon': 'https://banner2.cleanpng.com/20180719/piz/kisspng-north-carolina-wesleyan-college-library-science-no-library-icon-5b50c910354111.3735460915320210082181.jpg', 'level': 1, 'lessonsCompleted': 0},
            {'title': 'standard library 3', 'icon': 'https://banner2.cleanpng.com/20180719/piz/kisspng-north-carolina-wesleyan-college-library-science-no-library-icon-5b50c910354111.3735460915320210082181.jpg', 'level': 1, 'lessonsCompleted': 0},
        ],

        [
            {'title': 'standard library 4', 'icon': 'https://banner2.cleanpng.com/20180719/piz/kisspng-north-carolina-wesleyan-college-library-science-no-library-icon-5b50c910354111.3735460915320210082181.jpg', 'level': 1, 'lessonsCompleted': 0},
            {'title': 'standard library 5', 'icon': 'https://banner2.cleanpng.com/20180719/piz/kisspng-north-carolina-wesleyan-college-library-science-no-library-icon-5b50c910354111.3735460915320210082181.jpg', 'level': 1, 'lessonsCompleted': 0},
            {'title': 'external packages', 'icon': 'https://banner2.cleanpng.com/20180719/piz/kisspng-north-carolina-wesleyan-college-library-science-no-library-icon-5b50c910354111.3735460915320210082181.jpg', 'level': 1, 'lessonsCompleted': 0},
        ],

        [
            {'type': 'checkpoint', 'title': 'checkpoint 5', 'icon': 'https://cdn.iconscout.com/icon/premium/png-256-thumb/checkpoint-1673231-1420281.png'}
        ],

    ]
}

function getLessons2(){
    return {
    "chapters": [
        {
            "title": "Getting Started with Python",
            "description": "📌 Start coding in Python in minutes!",
            "units": [
                {"title": "Hello, Python!", "subtitle": "", "description": "Run your first Python script.", "tags": ["print()", "syntax"], "lessons": []},
                {"title": "Working with Data", "subtitle": "", "description": "Store and use numbers & text.", "tags": ["variables", "types"], "lessons": []},
                {"title": "User Input & Output", "subtitle": "", "description": "Interact with users.", "tags": ["input()", "f-strings"], "lessons": []},
                {"title": "Making Decisions", "subtitle": "", "description": "Smart programs with if-else.", "tags": ["boolean logic"], "lessons": []},
                {"title": "Loops & Automation", "subtitle": "", "description": "Make Python do the work.", "tags": ["for", "while"], "lessons": []}
            ]
        },
        {
            "title": "Reusable Code & Functions",
            "description": "📌 Stop repeating yourself – let Python do the work!",
            "units": [
                {"title": "Why Use Functions?", "subtitle": "", "description": "The power of reusability.", "tags": ["def", "return"], "lessons": []},
                {"title": "Making Functions Flexible", "subtitle": "", "description": "Inputs & arguments.", "tags": ["parameters", "default values"], "lessons": []},
                {"title": "Avoiding Errors", "subtitle": "", "description": "Making programs crash-proof.", "tags": ["try", "except"], "lessons": []},
                {"title": "Lists & Dictionaries", "subtitle": "", "description": "Storing and organizing data.", "tags": ["list", "dict"], "lessons": []}
            ]
        },
        {
            "title": "Working with Files & the Web",
            "description": "📌 Use Python for practical tasks!",
            "units": [
                {"title": "Reading & Writing Files", "subtitle": "", "description": "Save and load data.", "tags": ["open()", "read()", "write()"], "lessons": []},
                {"title": "Handling CSV & JSON", "subtitle": "", "description": "Work with real-world data.", "tags": ["csv", "json"], "lessons": []},
                {"title": "Web Scraping Basics", "subtitle": "", "description": "Extracting info from websites.", "tags": ["requests", "BeautifulSoup"], "lessons": []}
            ]
        },
        {
            "title": "Object-Oriented Thinking",
            "description": "📌 Learn how real-world programs are structured!",
            "units": [
                {"title": "What are Classes & Objects?", "subtitle": "", "description": "OOP made simple.", "tags": ["class", "object"], "lessons": []},
                {"title": "Methods & Attributes", "subtitle": "", "description": "Adding functionality.", "tags": ["self", "__init__()"], "lessons": []},
                {"title": "Inheritance & Reusability", "subtitle": "", "description": "Building on existing code.", "tags": ["super()"], "lessons": []}
            ]
        },
        {
            "title": "Automating Everyday Tasks",
            "description": "📌 Save time by letting Python handle things for you!",
            "units": [
                {"title": "Automating File Tasks", "subtitle": "", "description": "Copying, moving, renaming files.", "tags": ["os", "shutil"], "lessons": []},
                {"title": "Sending Emails & Messages", "subtitle": "", "description": "Automating communication.", "tags": ["smtplib", "email"], "lessons": []},
                {"title": "Web Scraping for Fun", "subtitle": "", "description": "Extracting data from the web.", "tags": ["requests", "selenium"], "lessons": []},
                {"title": "Simple Data Visualization", "subtitle": "", "description": "Turn data into graphs.", "tags": ["matplotlib", "seaborn"], "lessons": []}
            ]
        },
        {
            "title": "Working with APIs & Databases",
            "description": "📌 Python is everywhere – learn how to connect it to the world!",
            "units": [
                {"title": "What are APIs?", "subtitle": "", "description": "Talking to web services.", "tags": ["requests", "REST"], "lessons": []},
                {"title": "Working with a Weather API", "subtitle": "", "description": "Real-world data fetching.", "tags": ["json", "API keys"], "lessons": []},
                {"title": "Databases Made Simple", "subtitle": "", "description": "Store & retrieve data.", "tags": ["sqlite3"], "lessons": []}
            ]
        },
        {
            "title": "Testing, Debugging & Best Practices",
            "description": "📌 Write clean, bug-free Python code!",
            "units": [
                {"title": "Debugging Like a Pro", "subtitle": "", "description": "Fixing mistakes fast.", "tags": ["print()", "pdb"], "lessons": []},
                {"title": "Writing Maintainable Code", "subtitle": "", "description": "Style & best practices.", "tags": ["PEP 8", "comments"], "lessons": []},
                {"title": "Basic Testing", "subtitle": "", "description": "Ensure your code works.", "tags": ["assert", "unittest"], "lessons": []}
            ]
        },
        {
            "title": "Fun Python Projects & Next Steps!",
            "description": "📌 Apply what you’ve learned in cool real-world projects!",
            "units": [
                {"title": "Mini Project: A Personal Expense Tracker", "subtitle": "", "description": "Manage personal finances with Python.", "tags": [], "lessons": []},
                {"title": "Mini Project: Automate Renaming Photos", "subtitle": "", "description": "Organize your photo collection.", "tags": [], "lessons": []},
                {"title": "Mini Project: A Simple Web Scraper", "subtitle": "", "description": "Extract data from websites.", "tags": [], "lessons": []},
                {"title": "Where to Go Next?", "subtitle": "", "description": "Learning beyond the basics.", "tags": [], "lessons": []}
            ]
        }
    ]
}
}


const initialState = {
    isLoggedIn: true, // Set to true to bypass authentication
    accessToken: "mock_token", // Mock token
    error: '',
  isSending: false,
  answer: '',
  testsRunning: false,
  userProfile: {
    nick: 'Anonymous',
    slug: '',
    avatar: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTMEuWxEdT234XVE74W5H1ieglcXsegSzUV-ZCqZVftGEZpDknR&s',
    language: 'en',
    //'timeZone': '',
    //'bits': 0,
    expGained: [0, 0, 0, 0, 0, 0, 0],
    dailyGoal: 30,
    expGainedToday: 0,
    streakDays: 105,
    bits: 1050,
    hearts: 4,
  },
  courseInfo: {
    python: {lessons: getLessons()}, //TODO: getLessons2()
    html_css: {lessons: []},
    javascript: {lessons: []},
  },
  currentCourse: 'python', //TODO: get from API, the latest course user completed a lesson or set as default
  chosenAnswers: [],
  /*lesson: {
    name: 'numbers',
    level: 1,
    questions: questionsNumbers//mockQuestions
  }*/
  lesson: {
    questions: []
  }
};



const playgroundReducer = (state = initialState, action) => {
    switch (action.type) {
        // You can add more actions if needed
        default:
            return state;
    }
};
const playgroundStore = createStore(playgroundReducer)//, preloadedState);


class Playground extends Component {


    componentDidMount(){
        //TODO: fetch special token from API, it should be set by the other part of the app and retrieved once here
        //put({type: 'SYNCHRONIZE_TEST_STATE_REQUEST', testId: getAuthToken()})
    }

    render () {
        //TODO: remove /debug/* from prod router
        // add store, streak, profile, hearts to prod
        return (
            <Provider store={playgroundStore}>
                <Router history={history}>
                    <I18nextProvider i18n={i18n}>
                        <App>
                            <Suspense fallback={<div></div>}>
                                <Switch>
                                    <Route path='/courses' component={CoursesDashboard} />

                                    <Route path='/learn' component={Dashboard} />
                                    <Route path='/learn/:language' render={<div/>} />
                                    <Route path='/lesson/:language/:lessonTitle/:level' component={Lesson}/>

                                    <Route path='/profile' component={Profile}/>
                                    <Route path='/profile/:userSlug' component={Profile}/>

                                    <Route path='/store' component={Store}/>
                                    <Route path='/streak' component={Streak}/>
                                    <Route path='/feed' component={Feed}/>
                                    <Route path='/league' component={League}/>

                                    <Route path='/terms-and-conditions' render={()=> <TermsAndConditions/>}/>
                                    <Route path='/privacy-policy' render={()=> <PrivacyPolicy/>}/>
                                    <Route path='/about' render={()=> <About/>}/>
                                    <Route path='/initial-test' render={()=><InitialTest/>}/>
                                    <Route path='/join/:invitationHash' render={() => isAuth()?<Redirect to="/learn"/>: <Auth/>}/>


                                    <Route path='/debug/courses' render={() => <CoursesDashboard/>} />
                                    <Route path='/debug/lesson/:language/:lessonTitle/:level' render={() => <Lesson/>}/>
                                    <Route path='/debug/lesson/introduction' render={() => <LessonIntroduction lessonTitle={'Numbers'} lessonIntroductionContent={'Hello, this is code: <br> `print("hello world!")`'}/>} />
                                    <Route path='/debug/lesson/completed' render={()=><LessonCompleted exp={15} time={112.5} accuracy={92}/>} />
                                    <Route path='/debug/learn' component={Dashboard}/>} />
                                    <Route path='/debug/profile' component={Profile}/> />


                                    <Route path='*' render={() => <Redirect to="/debug/courses"/>} />
                                </Switch>
                            </Suspense>
                        </App>
                    </I18nextProvider>
                </Router>
            </Provider>
        )
    }
}



//TODO: uncomment to check playground locally
//ReactDOM.render(<Playground/>, document.getElementById("root"));


ReactDOM.render(<AppFlow />, document.getElementById('root'))


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();